import React from 'react'
import PropTypes from 'prop-types'
import { Box, SvgIcon, Typography, Divider, IconButton, styled, Stack } from '@mui/material'
import Grid from '@mui/material/Grid'
import { ReactComponent as MultiplicationSign } from 'assets/MultiplicationSign.svg'
import { ReactComponent as EqualSign } from 'assets/EqualSign.svg'
import { XCircle as UnstyledXCircle } from '@styled-icons/heroicons-solid/XCircle'
import { useFormContext } from 'react-hook-form'
import T from 'T'
import { HHFormNumberField, HHFormPriceField, HHFormSelectField } from '../../../form-fields/v5'
import HHDisplayMoney from '../../../common/HHDisplayMoney'

const XCircle = styled(UnstyledXCircle)({
  height: '20px',
  width: '20px',
})

const GeneralFeeFormRow = ({ index, generalFeeList, watch, onFeeChange, onRemove }) => {
  const { control } = useFormContext()
  const getFeeOptionLabel = ({ feeName }) => feeName
  const getFeeOptionValue = ({ id }) => id

  const charge = watch(`fees.${index}.feeCharge`)
  const qty = watch(`fees.${index}.quantity`)
  const total = (charge * qty).toFixed(2)
  const handleFeeChange = id => {
    onFeeChange({ feeId: id, index })
  }

  const handleClick = () => {
    onRemove(index)
  }

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
        <Grid size="grow">
          <Typography variant="h4" fontWeight={600}>{`${T.FEE} #${index + 1}`}</Typography>
        </Grid>
        <Grid>
          <IconButton onClick={handleClick}>
            <SvgIcon>
              <XCircle />
            </SvgIcon>
          </IconButton>
        </Grid>
      </Grid>
      <Grid size={12}>
        <HHFormSelectField
          size="small"
          options={generalFeeList}
          control={control}
          name={`fees.${index}.feeTaxId`}
          fullWidth
          onChange={handleFeeChange}
          getOptionValue={getFeeOptionValue}
          getOptionLabel={getFeeOptionLabel}
        />
      </Grid>
      {/* Row */}
      <Grid container wrap="nowrap" columnSpacing={1} size={12}>
        <Grid>
          <HHFormNumberField
            sx={{ width: '6rem' }}
            deprecatedLabel={false}
            label={T.QTY}
            size="small"
            control={control}
            name={`fees.${index}.quantity`}
          />
        </Grid>
        <Grid>
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <SvgIcon inheritViewBox viewBox=" 0 0 20 20" sx={{ width: '20px', height: '20px' }}>
              <MultiplicationSign />
            </SvgIcon>
          </Box>
        </Grid>
        <Grid size="grow">
          <HHFormPriceField
            fullWidth
            deprecatedLabel={false}
            label={T.COST}
            size="small"
            control={control}
            name={`fees.${index}.feeCharge`}
          />
        </Grid>
        <Grid>
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <SvgIcon inheritViewBox viewBox=" 0 0 20 20" sx={{ width: '20px', height: '20px' }}>
              <EqualSign />
            </SvgIcon>
          </Box>
        </Grid>
        <Grid>
          <Stack justifyContent="center" alignItems="center" height="100%">
            <Typography variant="h4" align="right" fontWeight={600}>
              <HHDisplayMoney value={total} formatToDollars={false} />
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      <Grid container size={12}>
        <Divider />
      </Grid>
    </>
  )
}

GeneralFeeFormRow.propTypes = {
  index: PropTypes.number,
  generalFeeList: PropTypes.array,
  onFeeChange: PropTypes.func,
  onRemove: PropTypes.func,
}

export default GeneralFeeFormRow
